/** @jsx jsx */
import { useCallback } from 'react';
import { css, jsx } from '@emotion/react';
import { getAppStore } from './store';
import { getModuleSync } from './module-loader';
import defaultI18nMessages from './translations/default';
import { SessionManager } from './session-manager';
function getStyle(theme) {
    return css `
    .oauth-error-page {
      width: 100vw;
      height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      .sign-in-btn {
        padding: 0.25rem 1rem;
        font-size: 14px;
        user-select: none;
        line-height: 1.5;
        border-radius: 2px;
        color: #fff;
        background: #007f94;
        border-width: 1px;
        border-style: solid;
        border-color: #007f94;
        margin-top: 20px;
        outline: none;
        min-width: 241px;
        height: 49px;
        margin: 79px 35px;
        cursor: pointer;
      }
    }`;
}
export function OAuthErrorPage(props) {
    const { oauthErrorCode, fromUrl, intl, theme } = props;
    const onSignInBtnClick = useCallback(() => {
        var _a, _b;
        const sessionManager = SessionManager.getInstance();
        sessionManager.signIn({ fromUrl: fromUrl || ((_a = window.location) === null || _a === void 0 ? void 0 : _a.href), popup: false, desUrl: (_b = getAppStore().getState()) === null || _b === void 0 ? void 0 : _b.portalUrl });
    }, [fromUrl]);
    const { Button } = getModuleSync('jimu-ui');
    const color = window.jimuConfig.isBuilder || window.jimuConfig.isSite ? 'white' : 'black';
    const backgroundColor = window.jimuConfig.isBuilder || window.jimuConfig.isSite ? '#232323' : '#f0f0f0';
    let errorMessage = '';
    switch (oauthErrorCode) {
        case 'OAUTH_0020':
            errorMessage = intl.formatMessage({ id: 'publicUserError', defaultMessage: defaultI18nMessages.publicUserError });
            break;
        case 'OAUTH_0033':
            errorMessage = intl.formatMessage({ id: 'essentialAppsLicenseErrorForBuilder', defaultMessage: defaultI18nMessages.essentialAppsLicenseErrorForBuilder });
            break;
        default:
            errorMessage = intl.formatMessage({ id: 'signInErrorDefault', defaultMessage: defaultI18nMessages.signInErrorDefault });
    }
    return (jsx("div", { css: getStyle(theme) },
        jsx("div", { id: "oauthError", className: 'oauth-error-page', style: { color, backgroundColor } },
            jsx("div", { id: "foo", dangerouslySetInnerHTML: { __html: errorMessage } }),
            jsx("div", { style: { display: 'flex' } }, Button && jsx(Button, { className: 'sign-in-btn', size: 'lg', onClick: onSignInBtnClick }, intl.formatMessage({ id: 'signIn', defaultMessage: 'Sign in' }))))));
}
